import { PaletteOptions } from "@mui/material/styles";

const palette: PaletteOptions = {
	primary: {
		main: "#2196F3", // Primary blue
		light: "#64B5F6",
		dark: "#1976D2",
		contrastText: "#FFFFFF",
	},
	secondary: {
		main: "#FF4081", // Pink accent
		light: "#FF80AB",
		dark: "#F50057",
		contrastText: "#FFFFFF",
	},
	error: {
		main: "#F44336", // Error red
		light: "#E57373",
		dark: "#D32F2F",
		contrastText: "#FFFFFF",
	},
	warning: {
		main: "#FFA726", // Warning orange
		light: "#FFB74D",
		dark: "#F57C00",
		contrastText: "#000000",
	},
	info: {
		main: "#29B6F6", // Info light blue
		light: "#4FC3F7",
		dark: "#0288D1",
		contrastText: "#FFFFFF",
	},
	success: {
		main: "#66BB6A", // Success green
		light: "#81C784",
		dark: "#388E3C",
		contrastText: "#FFFFFF",
	},
	grey: {
		50: "#FAFAFA",
		100: "#F5F5F5",
		200: "#EEEEEE",
		300: "#E0E0E0",
		400: "#BDBDBD",
		500: "#9E9E9E",
		600: "#757575",
		700: "#616161",
		800: "#424242",
		900: "#212121",
	},
	background: {
		default: "#FFFFFF",
		paper: "#FFFFFF",
	},
	text: {
		primary: "rgba(0, 0, 0, 0.87)",
		secondary: "rgba(0, 0, 0, 0.6)",
		disabled: "rgba(0, 0, 0, 0.38)",
	},
	divider: "rgba(0, 0, 0, 0.12)",
	action: {
		active: "rgba(0, 0, 0, 0.54)",
		hover: "rgba(0, 0, 0, 0.04)",
		selected: "rgba(0, 0, 0, 0.08)",
		disabled: "rgba(0, 0, 0, 0.26)",
		disabledBackground: "rgba(0, 0, 0, 0.12)",
		selectedOpacity: 0.25,
	},
};

export default palette;
